<mat-form-field appearance="outline" class="full-width" [ngClass]="{'error-border': control.invalid && (control.dirty || isSubmit)}">
  <!-- <mat-label>{{ label }}</mat-label> -->
   <div style="display: flex; align-items: center;">
    <img *ngIf="icon" src="../../../../assets/images/svgs/lock_outline_24px.png" alt="" style="margin-right: 11px;">
    <input matInput [type]="hide() ? 'password' : 'text'" [placeholder]="placeholder" [formControl]="control" (input)="onInputChange($event)"/>
   </div>
  
  <button mat-icon-button matSuffix type="button" (click)="clickEvent($event)" [attr.aria-label]="'Hide password'"
    [attr.aria-pressed]="hide()">
    <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
  </button>
  <!-- <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)"> -->
  <mat-error *ngIf="control?.invalid && (control?.dirty || isSubmit)">
    {{ errorMessage }}
    <!-- <span *ngIf="showRequiredError && control?.hasError('required')" class="errorTxt">
      {{errorMessage}}
    </span> -->
  </mat-error>  
</mat-form-field>